import { get } from '../util/request';
import Delivery from './delivery';

const api = 'https://query.aliyun.com/rest';

const renderDeliveryComponent = async () => {
  try {
    if (window.innerWidth > 768) {
      const { data: result } = await get(`${api}/delivery.service.engine?url=${window.location.href}`);
      // 若匹配到 content 则渲染投放组件，若未匹配到 content 则使用自定义配置
      const configList = result.data || [];
      configList.forEach(async config => {
        if (config.content) {
          const { data } = await get(`${api}/delivery.config.uiVersion`);
          const { component, isGray } = data;
          const { name, version } = component;
          // 灰度开关打开且带有灰度参数的页面才渲染组件
          if (isGray && !Delivery.switch()) return;
          Delivery.renderComponent(name, version, config);
        } else {
          Delivery.renderOther(config.customRule);
        }
      });
    }
  } catch (error) {
    console.log('error', error);
  }
};

const execution = () => {
  renderDeliveryComponent();
};

export default execution;



// WEBPACK FOOTER //
// ./src/components/defaultExecution.js